import { FC } from 'react';
import { ListChoice } from './ListChoice';
import type { useListSelection } from './useListSelection';

interface Props { state: ReturnType<typeof useListSelection> }

export const ListChoices: FC<Props> = ({ state }) => {
  const { lists, missing, visible, selected, toggle } = state;
  const retry = () => { void lists.refetch(); };
  if (lists.isPending) return <p className="text-xs" role="status">Loading lists…</p>;
  if (lists.isError) return <div className="text-xs" role="alert">Could not load lists. <button type="button" onClick={retry}>Retry</button></div>;
  return (
    <div className="max-h-60 overflow-y-auto">
      {missing.map((id) => (
        <ListChoice key={id} id={id} name={`Unavailable list #${id}`} checked onToggle={toggle} />
      ))}
      {visible.map((list) => (
        <ListChoice key={list.id} id={list.id} name={list.name || `#${list.id}`} checked={selected.includes(list.id)} onToggle={toggle} />
      ))}
      {!visible.length ? <p className="p-1.5 text-xs text-muted-foreground">No lists found.</p> : null}
    </div>
  );
};
